export default __webpack_public_path__ + "static/media/Brice-Regular.f659e24e.otf";